import { render, staticRenderFns } from "./crudSurrenderSeller.vue?vue&type=template&id=6067aa2c&"
import script from "./crudSurrenderSeller.vue?vue&type=script&lang=js&"
export * from "./crudSurrenderSeller.vue?vue&type=script&lang=js&"
import style0 from "./crudSurrenderSeller.vue?vue&type=style&index=0&id=6067aa2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports